module.exports = __webpack_public_path__ + "img/2013-01_bloomberg.33fb1d50.jpg";